/** Single place for contact and plan copy used by the marketing site. */
export const CONTACT_WA_NUMBER = '966537568318';
export const CONTACT_WA = (text: string) => `https://wa.me/${CONTACT_WA_NUMBER}?text=${encodeURIComponent(text)}`;

/**
 * Shop-side pricing after the GTM round (2026-10-19): one price, billing starts only after the 10th paying member,
 * the first 10 shops join as founding partners with no fees for 6 months. Never call any of this an "offer".
 */
export const TIERS = [
  { code: 'founding', name: 'شريك تأسيس', price: 0, period: 'لأول 10 محلات، 6 أشهر', bullets: ['كل ما في تيمبو', 'إعداد ميداني في محلك', 'مكالمة متابعة أسبوعية 15 دقيقة', 'نستخدم أرقام محلك كدراسة حالة بإذنك'], featured: true },
  { code: 'tempo', name: 'تيمبو', price: 149, period: 'شهريًا، السعر نهائي', bullets: ['حتى 100 عضو', 'لا تبدأ الفوترة قبل العضو العاشر', 'لوحة ورمز وبطاقات واتساب', 'شاشة المحل وتسجيل الدفع في المحل', 'تقرير الأسبوع على واتساب', 'دفتر الزبائن وتصديره'] },
  { code: 'chain', name: 'فروع', price: null, period: 'بالطلب', bullets: ['للمحل بأكثر من فرع تحت سجل واحد', 'لوحة موحدة للمالك', 'إعداد ميداني لكل فرع'] },
] as const;
